import React from "react";
import { Box } from "@material-ui/core";
import { Link } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    minHeight: "100vh",
    backgroundColor: "rgba(0, 0, 0, 0.9)",
    padding: theme.spacing(0.2),
  },
  label: {
    color: "white",
    fontFamily: "Raleway, sans-serif",
    fontWeight: "bold",
    fontSize: "5rem",
    marginBottom: theme.spacing(1.5),
  },

}));

function Unauthorized() {
  const classes = useStyles();
  return (
    <Box className={classes.root}>
      <h1 className={classes.label}>Unauthorized</h1>
      <p style={{color: "#747171", fontSize: "1.3rem"}}>You do not have permission to view this page.</p>
      <Link style={{color:"#FFC629", textDecoration: "none"}} to="/main-chat">Go back</Link>
    </Box>
  );
}

export default Unauthorized;
